import React from 'react';
import { Api } from '../../logic/Api/Api';

export interface IJdConnectOrgRequest
{
	OrganizationId: string;
	Farms: IJdConnectFarmRequest[];
}

export interface IJdConnectFarmRequest
{
	FarmId: string;
	Fields: IJdConnectFieldRequest[];
}

export interface IJdConnectFieldRequest
{
	FieldId: string;
	BoundaryId: string;
	Authorized: boolean;
}

/**
 * Post the results from the user's field selections to the server
 */
export function usePostJdConnectFields(
	invitationCode: string,
	isEnogen: boolean,
	api: Api,
	request: IJdConnectOrgRequest[],
	setMessage: (message:React.ReactNode) => unknown,
	startLoading: () => void, 
	endLoading: () => void
)
{
	startLoading();
	async function exec()
	{
		try 
		{
			
			const response = await api.postUnauthorizedAsync<boolean>(`6/jd-connect/invitations/${invitationCode}/fields`, request);

			if (response.Success) 
			{
				endLoading();
				let navLocation = '/jd-complete/';
				if (isEnogen)
				{
					// Add the Enogen theme flag
					navLocation += '?loginstyle=enogen';
				}
				// Redirect to complete page
				window.location.href = navLocation;
				return;
			}
			else
			{
				setMessage(<>{response.ErrorMessage}</>);
				return;
			}
		}
		catch (err) 
		{
			setMessage(<>An unknown error occurred. Please try again later.</>);
		}
	}
	exec();
}